import clsx from 'clsx';
import React from 'react';

import scss from './WithError.module.scss';

const WithError = ({ children, isAbsolute = false, isShowError, errorText, extraClassName }) => {
  return (
    <div className={clsx(scss['with-error'], isAbsolute && scss['with-error--absolute'], extraClassName)}>
      {children}
      {isShowError ? (
        <span className={clsx(scss['error'], isAbsolute && scss['error--absolute'])}>{errorText}</span>
      ) : null}
    </div>
  );
};

export default WithError;
